/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const BPayPaymentInstrumentR = t.interface({});

// optional attributes
const BPayPaymentInstrumentO = t.partial({
  defaultReceive: t.boolean,

  defaultSend: t.boolean,

  ibanObfuscated: t.string
});

export const BPayPaymentInstrument = t.intersection(
  [BPayPaymentInstrumentR, BPayPaymentInstrumentO],
  "BPayPaymentInstrument"
);

export type BPayPaymentInstrument = t.TypeOf<typeof BPayPaymentInstrument>;
